// extracted by mini-css-extract-plugin
export default {"title":"Video_title__RU3PB","container":"Video_container__KDlM7","responsiveframe":"Video_responsiveframe__Pn5Ag"};